import https from "@/lib/https";

export interface TeamCandidateCount {
  team_id: number;
  team_name: string;
  count: number;
}

export interface DashboardCandidatesData {
  active_candidates: number;
  avg_completion_percentage: number;
  total_candidates: number;
  total_docx_exports: number;
  total_exports: number;
  total_pdf_exports: number;
  teams: TeamCandidateCount[];
}

export interface DashboardCandidatesResponse {
  success: boolean;
  message: string;
  data: DashboardCandidatesData;
}

export const getDashboardCandidates =
  async (): Promise<DashboardCandidatesResponse> => {
    return await https.get<DashboardCandidatesResponse>(
      "/api/dashboard/candidates/",
    );
  };
